const config = {
  // apiUrl: process.env.REACT_APP_ENV === 'dev' ? 'http://localhost:4000' : 'http://173.209.40.26:4000',
  apiUrl: process.env.REACT_API_URL || "/api",
};

export default config;
